import React, { useMemo } from 'react';
import { Spin } from 'antd';
import { useQuery } from '@tanstack/react-query';
import {
	getResellerByCode,
	getResellerByDomain,
	getResellerLogo,
} from '@/api/unbrandedReceptionist';
import { BRANDED_DOMAINS, UNBRANDED_DOMAINS } from 'src/enums/ERoutes';

interface Props {
	debrand: boolean;
	resellerCode?: string;
	customDomain?: string;
}

const ResellerImage: React.FC<Props> = ({ debrand, resellerCode, customDomain }) => {
	const hostname = customDomain || window.location.hostname.replace(/^www\./, '');
	const isCustomDomain =
		!BRANDED_DOMAINS.includes(hostname) && !UNBRANDED_DOMAINS.includes(hostname);
	const useCustomDomain = isCustomDomain && !resellerCode;

	const { data: resellerData, isLoading: isResellerLoading } = useQuery({
		queryKey: useCustomDomain ? ['reseller-domain', hostname] : ['reseller-code', resellerCode],
		queryFn: () =>
			useCustomDomain
				? getResellerByDomain({ domain: hostname })
				: getResellerByCode({ resellerCode: resellerCode || '' }),
		enabled: isCustomDomain || !!resellerCode,
	});

	const reseller = resellerData?.reseller;

	const { data: resellerLogo, isLoading: isLogoLoading } = useQuery({
		queryKey: ['reseller-logo', reseller?.logo],
		queryFn: () => getResellerLogo({ key: reseller?.logo }),
		enabled: !!reseller?.logo,
		refetchOnWindowFocus: false,
		refetchOnMount: false,
	});

	const resellerLogoUrl = useMemo(() => {
		if (!resellerLogo) {
			return undefined;
		}
		return URL.createObjectURL(resellerLogo);
	}, [resellerLogo]);

	const isLoading = isResellerLoading || isLogoLoading;

	if (!debrand && !isCustomDomain) {
		return null;
	}

	return (
		<div className=" flex justify-center items-center">
			{isLoading ? (
				<Spin className="mt-20" />
			) : resellerLogoUrl ? (
				<img
					style={{
						width: `${reseller?.logoDimensions?.width?.N || 64}px`,
						height: `${reseller?.logoDimensions?.height?.N || 64}px`,
						objectFit: 'contain',
					}}
					src={resellerLogoUrl}
					alt="logo"
				/>
			) : (
				<h1> {reseller && reseller?.reseller_name} </h1>
			)}
		</div>
	);
};

export default ResellerImage;
